import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLang } from "@/i18n/LanguageProvider";
import { openConsentSettings } from "@/lib/consent";

export function SiteFooter() {
  const { t } = useTranslation("common");
  const { href, lang } = useLang();
  const radarLabel = lang === "en" ? "Flight radar" : "Flygradar";
  const sePath = lang === "en" ? "/en/flight-radar/sweden" : "/flygradar/sverige";
  const euPath = lang === "en" ? "/en/flight-radar/europe" : "/flygradar/europa";
  const livePath = lang === "en" ? "/en/live" : "/live";
  const privacyPath = lang === "en" ? "/en/privacy" : "/integritetspolicy";
  const termsPath = lang === "en" ? "/en/terms" : "/villkor";
  const cookiesPath = lang === "en" ? "/en/cookies" : "/cookies";
  const tConsent = useTranslation("consent").t;
  return (
    <footer className="border-t border-rule mt-16">
      <div className="px-6 md:px-10 py-6 grid gap-5 text-xs text-muted-foreground sm:grid-cols-2">
        <div className="space-y-2">
          <div>© {new Date().getFullYear()} Flyg.info — {t("footer.tagline")}</div>
          <nav className="flex flex-wrap items-center gap-x-4 gap-y-1" aria-label={radarLabel}>
            <span className="uppercase tracking-[0.18em] text-[10px] mr-1">{radarLabel}:</span>
            <Link to={sePath} className="hover:text-foreground transition-colors">
              {lang === "en" ? "Sweden" : "Sverige"}
            </Link>
            <Link to={euPath} className="hover:text-foreground transition-colors">
              {lang === "en" ? "Europe" : "Europa"}
            </Link>
            <Link to={livePath} className="hover:text-foreground transition-colors">
              {lang === "en" ? "Flights in the air" : "Flyg i luften"}
            </Link>
            <Link to={href("/airport/ARN")} className="hover:text-foreground transition-colors">ARN</Link>
            <Link to={href("/airport/GOT")} className="hover:text-foreground transition-colors">GOT</Link>
          </nav>
        </div>
        <div className="flex flex-wrap items-center gap-4 sm:justify-end">
          <Link to={href("/spel")} className="hover:text-foreground transition-colors">
            🎯 {t("footer.game")}
          </Link>
          <Link to={href("/reseservice")} className="hover:text-foreground transition-colors">
            {t("footer.reseservice")} <span>{t("footer.ad")}</span>
          </Link>
          <a
            href="https://flightsto.eu/"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-foreground transition-colors"
          >
            flightsto.eu
          </a>
          <a
            href="https://xn--frsenad-90a.se/"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-foreground transition-colors"
          >
            försenad.se
          </a>
        </div>
      </div>
      <div className="px-6 md:px-10 pb-5 -mt-2 flex flex-wrap items-center gap-x-4 gap-y-1 text-[11px] text-muted-foreground">
        <Link to={privacyPath} className="hover:text-foreground transition-colors">
          {lang === "en" ? "Privacy" : "Integritetspolicy"}
        </Link>
        <Link to={termsPath} className="hover:text-foreground transition-colors">
          {lang === "en" ? "Terms" : "Villkor"}
        </Link>
        <Link to={cookiesPath} className="hover:text-foreground transition-colors">
          Cookies
        </Link>
        <button
          type="button"
          onClick={() => openConsentSettings()}
          className="hover:text-foreground transition-colors underline-offset-4 hover:underline"
        >
          {tConsent("footerSettings")}
        </button>
      </div>
    </footer>
  );
}